<div class="main-page-content container">
  <div class="main-page-content-block">
    <div class="row mb-3">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-end">
          <h1 class="content-heading-font mb-0">Applied Patches</h1>
          <div class="d-flex gap-2">
            <input class="form-control" type="text" placeholder="Filter by patch name" [(ngModel)]="patchName" (keyup.enter)="loadTable()" />
            <input class="form-control" type="date" [(ngModel)]="dateFrom" title="Date from" />
            <input class="form-control" type="date" [(ngModel)]="dateTo" title="Date to" />
            <button class="btn btn-primary" (click)="loadTable()" title="Search / Refresh">
              <i class="pi pi-refresh" [ngClass]="{ 'pi-spin': loadingList }"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <p-table [value]="list" [loading]="loadingList" styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 45px;"></th>
          <th>Patch Name</th>
          <th>Description</th>
          <th class="text-center" style="width: 130px;">Clients</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td class="text-center">
            <button type="button" class="btn btn-sm btn-link p-0" (click)="toggleRow(item)">
              <i class="pi" [ngClass]="isRowExpanded(item) ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </button>
          </td>
          <td>{{ item.Name }}</td>
          <td>{{ item.Description }}</td>
          <td class="text-center">{{ item.Clients?.length || 0 }}</td>
        </tr>

        <tr *ngIf="isRowExpanded(item)">
          <td colspan="4">
            <p-table [value]="item.Clients || []" dataKey="ID" styleClass="p-datatable-sm p-datatable-gridlines">
              <ng-template pTemplate="header">
                <tr>
                  <th>Client</th>
                  <th class="text-center" style="width: 90px;">Run</th>
                  <th class="text-center">ID</th>
                  <th class="text-center">Applied On</th>
                  <th>Apply Result</th>
                  <th class="text-center">Version</th>
                  <th class="text-center">Has Errors</th>
                  <th class="text-center">Run Counter</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-clientRow>
                <tr>
                  <td>
                    {{ clientRow.SiteName }}
                    <i *ngIf="clientRow.IsActive === false" class="pi pi-ban text-danger ms-2" title="Inactive client"></i>
                  </td>
                  <td class="text-center">
                    <button *ngIf="clientRow.IsActive !== false"
                            class="btn btn-sm btn-primary"
                            (click)="runPatchForClient(item, clientRow)"
                            title="Run patch for this client">
                      <i class="pi pi-play"></i>
                    </button>
                  </td>
                  <td class="text-center">{{ clientRow.ID }}</td>
                  <td class="text-center">{{ clientRow.AppliedOn | date:'short' }}</td>
                  <td>{{ clientRow.ApplyResult }}</td>
                  <td class="text-center">{{ clientRow.Version }}</td>
                  <td class="text-center">
                    <span class="badge" [ngClass]="getResultClass(clientRow.HasErrors)">
                      {{ clientRow.HasErrors ? 'Yes' : 'No' }}
                    </span>
                  </td>
                  <td class="text-center">{{ clientRow.RunCounter }}</td>
                </tr>
              </ng-template>
            </p-table>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">No patches found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
